// import history from "../history";

export const setMods = (mods) => ({
  type: 'SET_MODS',
  payload: mods
});
